// extracted by mini-css-extract-plugin
export default {"main":"InfoNav_main__IRRT5","container":"InfoNav_container__-idL+","exploreButton":"InfoNav_exploreButton__AnbWl","rightSection":"InfoNav_rightSection__uxWAq"};